/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Sh_NumberInputs */

const en_ccsl_export_header_sh_number = /** @type {(inputs: Ccsl_Export_Header_Sh_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SH #`)
};

const fr_ccsl_export_header_sh_number = /** @type {(inputs: Ccsl_Export_Header_Sh_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SH #`)
};

const de_ccsl_export_header_sh_number = /** @type {(inputs: Ccsl_Export_Header_Sh_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SH #`)
};

const it_ccsl_export_header_sh_number = /** @type {(inputs: Ccsl_Export_Header_Sh_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SH #`)
};

const ru_ccsl_export_header_sh_number = /** @type {(inputs: Ccsl_Export_Header_Sh_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ш #`)
};

const es_ccsl_export_header_sh_number = /** @type {(inputs: Ccsl_Export_Header_Sh_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SH #`)
};

const zh_cn2_ccsl_export_header_sh_number = /** @type {(inputs: Ccsl_Export_Header_Sh_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SH #`)
};

const ja_ccsl_export_header_sh_number = /** @type {(inputs: Ccsl_Export_Header_Sh_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SH #`)
};

const hi_ccsl_export_header_sh_number = /** @type {(inputs: Ccsl_Export_Header_Sh_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`श #`)
};

const pt_pt2_ccsl_export_header_sh_number = /** @type {(inputs: Ccsl_Export_Header_Sh_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SH #`)
};

/**
* | output |
* | --- |
* | "SH #" |
*
* @param {Ccsl_Export_Header_Sh_NumberInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_sh_number = /** @type {((inputs?: Ccsl_Export_Header_Sh_NumberInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Sh_NumberInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_sh_number(inputs)
	if (locale === "de") return de_ccsl_export_header_sh_number(inputs)
	if (locale === "it") return it_ccsl_export_header_sh_number(inputs)
	if (locale === "ru") return ru_ccsl_export_header_sh_number(inputs)
	if (locale === "es") return es_ccsl_export_header_sh_number(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_sh_number(inputs)
	if (locale === "ja") return ja_ccsl_export_header_sh_number(inputs)
	if (locale === "hi") return hi_ccsl_export_header_sh_number(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_sh_number(inputs)
	return en_ccsl_export_header_sh_number(inputs)
});